import React, { Component } from "react";
import { Image, StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { Body, Button, Container, Left, Right, Title } from "native-base";
import Header from "../../components/ui/WrappedHeader";
import { Translation } from "react-i18next";
import Icon from "react-native-vector-icons/Ionicons";

import { NavigationService } from "../../navigation";
import NavigateActionTypes from "../../navigation/NavigateActionTypes";

import UIDs from "../../UIDs";

import Dimensions from "react-native-web-dimension-helper";

const uid = UIDs.components.base.loadScreenErrorHandler;

const { width, height } = Dimensions.get("window");

class LoadScreenErrorHandler extends Component {

    localVars = {
        notSupportedBackScreens: null
    };

    constructor(props) {
        super(props);

        this.localVars.notSupportedBackScreens = [
            UIDs.screens.homework.newdefault,
            UIDs.screens.homework.default,
            UIDs.screens.homework.newlist,
            UIDs.screens.me.default,
            UIDs.screens.account.login,
        ];
    }

    componentDidMount(){

    }

    render() {
        return (
            <Container>
                <Header style={[styles.headerColor,]}>
                    <Left style={[styles.flex1]} >
                        {!this.localVars.notSupportedBackScreens.includes(this.props.screenID) && <Button transparent onPress={() => this._handleBack()}>
                            <Icon name="ios-arrow-back" style={[ styles.headerIcon]}/>
                        </Button>}
                    </Left>
                    <Body style={[styles.flex3, styles.alignItemsCenter]}>
                        <Title style={[ styles.headerTitle]}>
                            <Translation ns={uid}>{(t) => t("title")}</Translation>
                        </Title>
                    </Body>
                    <Right style={[styles.flex1]}/>
                </Header>
                <View style={{ justifyContent: "center", alignItems: "center", flex: 1 }}>
                    <Image
                        source={require("../../images/error.png")}
                        style={{ width: 150, height: 150, resizeMode: "stretch" }}
                    />
                    <Text style={{ fontSize: 16, marginVertical: 20, marginHorizontal: 50 }}>
                        <Translation ns={uid}>{(t) => t("error",{ reason: this.props.error.message, code: this.props.error.code })}</Translation>
                    </Text>
                    {this.props.onReload ?
                     (<TouchableOpacity style={[styles.button, styles.justifyContentCenter, {marginBottom: 20}]} onPress={() => this.props.onReload()}>
                          <Text style={styles.buttonText}>
                              <Translation ns={uid}>{(t) => t("reload")}</Translation>
                          </Text>
                      </TouchableOpacity>) : null}
                </View>
            </Container>
        );
    }

    _handleBack() {
        NavigationService.navigateByAction(this, NavigateActionTypes.BACK);
    }
}

const styles = StyleSheet.create({
    centerAlign: {
        justifyContent: "center",
        alignItems: "center"
    },

    headerColor: {
        backgroundColor:"#fff"
    },

    headerTitle: {
        color:"#111"
    },

    flex1: {
        flex:1
    },

    flex3: {
        flex:3
    },

    alignItemsCenter: {
        alignItems:"center"
    },

    justifyContentCenter: {
        justifyContent:"center"
    },

    headerIcon: {
        fontSize:30,
        color:"#777"
    },

    button: {
        backgroundColor: '#2196f3',
        borderRadius: 50,
        padding: 16,
        width: width*0.6,
    },

    buttonText: {
        color: '#fff',
        fontWeight: '600',
        textAlign: 'center'
    },

});

export default LoadScreenErrorHandler;
